import { render, staticRenderFns } from "./StrategySettingModal.vue?vue&type=template&id=06ab8f98&scoped=true"
import script from "./StrategySettingModal.vue?vue&type=script&lang=js"
export * from "./StrategySettingModal.vue?vue&type=script&lang=js"
import style0 from "./StrategySettingModal.vue?vue&type=style&index=0&id=06ab8f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab8f98",
  null
  
)

export default component.exports